var logger = {
  exports: {}
};

export { logger as l };
//# sourceMappingURL=logger.js.map
